/* @flow strict */

import * as React from 'react';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { GET } from '/client/src/api';
// import _ from 'lodash';
import { validateInput } from '/client/src/utils/validateInput';

type PropsType = {
};

const Resend = ({}: PropsType): React.Element<typeof React.Fragment> => {
  const [ email, setEmail ] = React.useState('');
  const [isSendRequest, sendResetRequest] = React.useState(false);
  const emailValidationMessage = React.createRef();
  const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    const isValid = validateInput(emailValidationMessage.current, email);

    if (isValid) {
      try {
        setStatus('loading');

        const { success } = await GET(`/api/v1/1/account/check_email?email_address=${encodeURIComponent(email)}`);

        setStatus('success');
        sendResetRequest(true);
      } catch (error) {
        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    }
  };

  return (
    <>
      <div className="form-box-container">
        <div className="form-box-message">
          <h3 className="auth-message-header">
            {isSendRequest ?
              'Check your email' :
              'Resend email confirmation'
            }
          </h3>
          <div
            className="auth-message-desc"
          >
            {isSendRequest ?
              'A reset link was sent to:' :
              'Enter your email below.'
            }
          </div>
        </div>

        {isSendRequest ?
        <>
          <div className="email" style={{ margin: '.75rem 0' }}><b>{email}</b></div>
          <div style={{ lineHeight: 1.5 }}>
            Follow the instructions in that email to reset your password. &nbsp;
            Check all folders in your inbox including your spam folder.
          </div>
          <div style={{ marginTop: '2rem' }}>
            <span className="text">Can't find the email?</span>
            <div
              className="btn btn-sm btn-color-logo-outline btn-round"
              role="button"
              style={{ marginLeft: '1rem', borderRadius: '50px' }}
              onClick={() => {
                sendResetRequest(false);
              }}
            >
                Resend email confirmation
            </div>
          </div>
        </> :
        <form role="form">
          <div className="mt-4">
            <label htmlFor="email">Email</label>
            <div ref={emailValidationMessage}>
              <input
                className="form-control"
                type="email"
                title="This field is required."
                value={email}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  emailValidationMessage.current.classList.remove('has-error');
                  emailValidationMessage.current
                    .querySelector('input')
                    .classList
                    .remove('validationElement');
                  setEmail(e.target.value);
                }}
              />
              <span
                className="validationMessage"
              >This field is required.</span>
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-xs-12 text-center progress-button-50">
              <BtnLoader
                label='Resend Email'
                handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                  sendRequest(e, setStatus);
                }}
              />
            </div>
          </div>
        </form>
        }
      </div>
    </>
  );
};

export default Resend;
